<template>
  <v-hover v-slot="{ hover }">
    <div :class="{'d-flex align-center': showIcon}" @click.stop.prevent>
      <div>
        <slot></slot>
      </div>
      <v-btn v-if="showIcon" text icon x-small 
        width="24" 
        height="24" 
        :class="{
          'mx-1 copy-icon': alwaysVisible ? false : true,
          'hover': hover
        }" 
        @click="onCopyClick"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
    </div>
  </v-hover>

</template>

<script>
export default {
  name: "CopyToClipboard",
  props:{
    text: {
      type: String,
      required: true
    },
    alwaysVisible: {
      type: Boolean,
      default: false
    },
    feedbackText: {
      type: String,
      default: 'Kopierat'
    }
  },
  computed:{
    showIcon(){
      return this.alwaysVisible || !this.$vuetify.breakpoint.xs
    }
  },
  methods : {
    async onCopyClick(){
      try {
        await navigator.clipboard.writeText(this.text)
        this.$emit('on-copy')
        if (this.feedbackText) this.$events.fire('showInfo', this.feedbackText)
      } catch (error) {
        
      }
    }
  }
}
</script>
<style scoped>
.copy-icon {
  opacity: 0;
}
.copy-icon.hover {
  opacity: 1;
}
</style>